/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export class Config<T> {
  private config: T;

  constructor(initialConfig: T) {
    this.config = initialConfig;
  }

  getConfig(): T {
    return this.config;
  }

  setConfig(newConfig: T): void {
    this.config = newConfig;
  }
}
